import React from "react";
import { mapMarkerSelectionFilter } from "../../utils/map-selection-glow";

interface PostMarkerProps {
  onClick: () => void;
  onMouseOver: () => void;
  onMouseOut: () => void;
  title: string;
  isCategoryOrTagSelected: boolean;
  isActive: boolean;
  isSelected?: boolean;
  anchor?: [number, number];
}

const PostMarker: React.FC<PostMarkerProps> = ({
  onClick,
  onMouseOver,
  onMouseOut,
  title,
  isCategoryOrTagSelected,
  isActive,
}) => {
  const iconSrc = `../../../images/icons/marker.svg`;
  const size = isActive || isCategoryOrTagSelected ? 24 : 16;

  return (
    <img
      src={iconSrc}
      alt={title}
      onClick={onClick}
      onMouseOver={onMouseOver}
      onMouseOut={onMouseOut}
      style={{
        width: `${size}px`,
        height: `${size}px`,
        borderRadius: "50%",
        position: "absolute",
        top: `-0px`,
        left: `-0px`,
        cursor: "pointer",
        pointerEvents: "auto",
        filter: mapMarkerSelectionFilter(isActive),
        zIndex: "5",
      }}
    />
  );
};

export default React.memo(PostMarker);
